// additionalwork.component.ts
import { Component, Inject, OnInit } from '@angular/core';
import { AdditionalworkService, Item } from './additionalwork.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AuthService } from '../auth.service';
import { CityService } from '../cities/cities.service';
import { Region } from '../cities/cities/cities.component';

@Component({
  selector: 'app-additionalwork',
  templateUrl: './additionalwork.component.html',
  styleUrls: ['./additionalwork.component.css']
})
export class AdditionalworkComponent implements OnInit{
  items: Item[] = [];

  selectedItems: { item_id: number, item: string; note: string; who: string; time: Date }[] = [];
  user: any;
  usernamee: any;
  updateRow : boolean = false;
  loadPrevious : boolean = true;
  customer_id : number = null;
  regions: Region[] = [];
  selectedRegion: string = '';  

  constructor(
    private additionalWorkService: AdditionalworkService,
    private cityService: CityService,
    public dialogRef: MatDialogRef<AdditionalworkComponent>,
    public auth: AuthService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  ngOnInit(): void {

    this.additionalWorkService.getDropdownItems().subscribe((data: any) => {
      this.items = data.Data;
    });

    this.auth.userProfile$.subscribe(
      (profile) => {
        this.user = profile;
        this.usernamee = this.user ? this.user.nickname.charAt(0).toUpperCase() + this.user.nickname.slice(1) : '';
      });

      this.loadPrevious = typeof this.data.loadPrevious === undefined ?  true : this.data.loadPrevious; 
      this.customer_id = !(typeof this.data.customer_id === undefined) ?  this.data.customer_id : null ; 
      
      if(this.loadPrevious === true){

        this.additionalWorkService
        .getAdditionalWork(this.data.location_id, this.data.job_id)
        .subscribe(
          (res) => {
            if (res && res.Data.data) {
              this.updateRow = true;
              this.selectedItems = res.Data.data.map((item: any) => ({
                item_id: item.item_id,
                item: item.item,
                note: item.note,
                who: item.who,
                time: new Date(item.time), // Convert time string to Date object
              }));

              // Pre-select checkboxes for loaded items
              this.selectedItems.forEach((selected) => {
                const checkboxElement = document.querySelector(
                  `mat-checkbox[ng-reflect-name="${selected.item}"]`
                );
                if (checkboxElement) {
                  (checkboxElement as HTMLInputElement).checked = true;
                }
              });
            }
          },
          (err) => {
            console.error('Error loading additional work:', err);
          }
        );
      }
      //load regions
      this.cityService.getRegions().subscribe(data => {
        this.regions = data;
      })

  }

  getItemNote(item: string): string {
    const selectedItem = this.selectedItems.find((i) => i.item == item);
    return selectedItem ? selectedItem.note : '';
  }
  

  toggleItem(item: Item, checked: boolean): void {
    if (checked) {
      this.selectedItems.push({ item_id: item.id, item: item.work_desc, note: '', who: this.usernamee, time: new Date() });
    } else {
      this.selectedItems = this.selectedItems.filter((i) => i.item !== item.work_desc);
    }
  }

  isItemSelected(item: Item): boolean {
    return this.selectedItems.some((i) => i.item == item.work_desc);
  }
  
  updateNote(item: Item, note: string): void {
    const selectedItem = this.selectedItems.find((i) => i.item == item.work_desc);
    if (selectedItem) {
      selectedItem.note = note;
    }
  }

  save(): void {

    //validate the form
    if(this.selectedItems.length === 0){
      alert('Please select at least one item, or click cancel');
      return;
    }

    const otherItem = this.selectedItems.find((i) => i.item === 'Other');
    if (otherItem && otherItem.note == '') {
      alert('Please enter a note for Other');
      return;
    }

    let region = this.selectedRegion !== '' ? this.selectedRegion : 'N/A'
      this.additionalWorkService.saveAdditionalWork(this.data.location_id, this.data.job_id, this.selectedItems,this.updateRow, this.customer_id, region).subscribe(res =>{
      });
    this.dialogRef.close(1);
  }

  cancel(): void {
    this.dialogRef.close(2);
  }
}
